<template>
  <div class="mb-3">
    <div class="d-flex mb-2">
      <div class="mr-3">
        <div :style="{'padding-top':(type==='streak' ? '20px' : 0 )}">
          <v-icon :size="iconSize" :color="iconColor"
                  :style="{'margin-left':iconMargin, 'margin-top':iconMargin, 'margin-bottom':iconMargin,}">{{ icon }}
          </v-icon>
        </div>
        <div class="text-button">LEVEL {{ level }}</div>
      </div>
      <div style="width: calc(100% - 76px); min-height: 80px;">
        <div class="subtitle-1 font-weight-bold">{{ name }}</div>
        <div class="body-2 mt-2" style="min-height: 32px;">{{ text }}</div>
        <div v-if="type==='streak'" class="d-flex  justify-space-between">
          <div v-for="day in days" class="">
            <v-icon :color="day.hasRecords ? iconColor : 'grey lighten-2'">mdi-fire</v-icon>
            <p class="text-center text-caption">{{day.wochentag}}</p>
          </div>
        </div>
        <div class="d-flex mt-3" style="width: 100%;">
          <v-progress-linear :value="progress" :color="iconColor"></v-progress-linear>
          <div class="mt-n3 ml-3">{{ count }}/{{ nextLevelCount }}</div>
        </div>
      </div>
    </div>
    <v-divider v-if="!noDivider"></v-divider>
  </div>
</template>

<script>
import Kinds from "@/components/Kinds";
import {DateTime, Duration} from "luxon";

export default {
  name: "Challenge",
  props: ["name", "icon", "iconColor", "iconSize", "id", "subid", "type", "levels", "description", "noDivider"],
  data() {
    return {
      obj: undefined,
      maxLevel: false,
      nextLevelCount: 0,
      text: "...",
      days: [],
    }
  },
  async mounted() {
    console.log("this.type:", this.type)
    if (this.type === "streak") {
      this.obj = (await this.$backend.get_object(Kinds.KIND_STREAK, this.id)) || {Count:0, SevenDayReview:[false, false, false, false, false, false, false]};
      this.prepareDays(this.obj);
    } else if (this.type === "gaming") {
      this.obj = (await this.$backend.get_settings(this.id)) || {};
    }
  },
  methods: {
    prepareDays(streak) {
      var date = new Date(Date.now());
      //var id = date.toISOString().substr(0, 7); // YYYY-MM
      //console.log({streak})
      var today=DateTime.fromJSDate(date).setLocale("de");
      var lastWeek=today.minus(Duration.fromObject({days:6}));
      var hasRecords=false;
      for(var i = 0; i<7; i++){
        var day = lastWeek.plus(Duration.fromObject({days:i}));
        var wochentag=day.weekdayLong.substr(0,1);
        var iso = day.toISODate();
        hasRecords=streak.SevenDayReview[i]===true;
        this.days.push({wochentag, iso, hasRecords});
      }
    }
  },
  computed: {
    count() {
      if (!this.obj)
        return 0;
      if (this.type === "streak" || this.type === "medalStreak")
        return this.obj.Count || 0;
      if (this.type === "gaming")
        return this.obj[this.subid] || 0;
      return 0;
    },
    level() {
      if (!this.obj)
        return "?";
      if ((this.count || 0) >= this.levels[this.levels.length - 1]) {
        this.maxLevel = true;
        this.text = `Du hast das höchste Level erreicht`
        this.nextLevelCount = this.levels[this.levels.length - 1];
        return this.levels.length;
      }
      var i = 0;
      for (i = 0; i < this.levels.length; i++) {
        if (this.levels[i] > (this.count || 0))
          break;
      }
      //i = Math.max(0, i-1);
      this.text = this.description.replace("@", "" + this.levels[i]);
      this.nextLevelCount = this.levels[i];
      return i;
    },
    progress() {
      if (!this.nextLevelCount || !this.count)
        return 0;
      return this.count / this.nextLevelCount * 100;
    },
    iconMargin() {
      return "" + Math.round((64 - this.iconSize) / 2) + "px";
    },
  },
  watch: {}
}
</script>

<style scoped>

</style>